import { render, staticRenderFns } from "./TxTable.vue?vue&type=template&id=65e76f23&"
import script from "./TxTable.vue?vue&type=script&lang=js&"
export * from "./TxTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports